import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a7ed7e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main tw-overflow-x-hidden" }
const _hoisted_2 = {
  style: `
            width: 100%;
            position: relative;
            z-index: 0;
            
            `,
  class: /*#__PURE__*/_normalizeClass(`tw-bg-[#fff] xl:tw-px-[60px] tw-px-[10px] xl:tw-py-[55px] tw-py-[30px]`)
}
const _hoisted_3 = {
  style: {"line-height":"22px"},
  class: "title tw-text-2xl tw-font-semibold tw-text-[#211F58] tw-text-[22px]"
}
const _hoisted_4 = { class: "assessment-content" }
const _hoisted_5 = { class: "title-container tw-flex tw-items-center tw-justify-between" }
const _hoisted_6 = { class: "tw-my-0" }
const _hoisted_7 = { class: "title tw-mr-[10px]" }
const _hoisted_8 = { class: "group-button tw-flex tw-items-center" }
const _hoisted_9 = { class: "tw-flex tw-flex-col tw-gap-[25px] tw-mt-[20px] tw-w-full tw-rounded-[6px]" }
const _hoisted_10 = {
  key: 0,
  class: "custom-global-skeleton tw-w-full tw-h-[72px] tw-rounded-[6px]"
}
const _hoisted_11 = { class: "tw-relative tw-order-[1] md:tw-order-[2] tw-w-[100%] tw-flex tw-justify-center tw-rounded-br-md tw-rounded-bl-md tw-h-[fit-content] actionsWrapper tw-max-w-[241px] lg:tw-min-w-[241px]" }

import {
  Ref,
  computed,
  onBeforeUnmount,
  onMounted,
  onUnmounted,
  ref,
  watch,
} from "vue";
import AppBarLayout from "@/components/layouts/appBarLayout.vue";
import ButtonFilter from "@/components/common/setting/buttonFilter.vue";
import IconButton from "@/components/common/iconButton.vue";
import ButtonBulkActions from "@/components/common/setting/buttonBulkActions.vue";
import backgroundComponent from "@/components/common/backgroundComponent.vue";
import ActionButton, { Action } from "@/components/common/actionButton.vue";
import { addCurrentItemToChild, getComponentUiText } from "@/utils/utilities";
import BrandPattern4 from "@/components/prospect/brandPattern/brandPattern4.vue";
import AssessmentCreateButton from "@/components/assessment/assessmentCreateButton.vue";
import CreateAssessmentModal from "@/components/assessment/createAssessmentModal.vue";
import { processChecklistAssessmentDataNewVerson } from "@/services/assessment";
import { Assessment } from "@/services/apiRoutes/routes";
import { showErrorAPI } from "@/services/apiRoutes";
import PlusWrappedIcon from "@/components/svgs/plusWrappedIcon.vue";
import UserIcon from "@/components/svgs/userIcon.vue";
import AssessmentDetails from "@/components/assessment/assessmentDetails.vue";
import { IAssessmentDetail } from "@/interfaces/assessments/IAssessmentDetails";
import { convertUTCTimeToLocalTime } from "@/utils/dateTimeUtils";
import get from "lodash/get";
import store from "@/store";
import { localStorageKey } from "@/utils/constants";
import { useRoute } from "vue-router";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import router from "@/router";
import ManageTemplateModal from "@/components/assessment/manageTemplateModal.vue";
import ActivePathWrapper from "@/components/common/activePathWrapper.vue";
import cloneDeep from "lodash/cloneDeep";


export default /*#__PURE__*/_defineComponent({
  __name: 'assessment',
  setup(__props) {

const profileActions: Action[] = [
  {
    icon: PlusWrappedIcon,
    iconColor: "#211F58",
    title: "app-assessment-view-exposures-1",
    titleClass: "tw-max-w-[175px]",
    onClick: () => {
      router.push({ path: "/assess/roadmap" });
    },
  },
  {
    id: "ma-btn-manage-teamplates",
    icon: UserIcon,
    title: "app-assessment-assessment-settings-manage-templates-1",
    titleClass: "tw-max-w-[175px]",
    onClick: () => {
      showModalManageTemplate.value = true;
    },
  },
];

let isActiveBulkActions: Ref<boolean> = ref(false);
const route = useRoute();
const backgroundRef = ref(null);
const listAssessmentSelected: string[] = [];
const assessmentSelectedCount = ref(0);
const assessmentsHistory = ref<
  {
    name: string;
    state: string;
    date: string;
    isLarge: boolean;
    history: any[];
  }[]
>([]);
// const checklistDetailData: Ref<IAssessmentDetail[]> = ref([]);
const createAssessmentShow = ref(false);
const showModalManageTemplate = ref(false);
const isChecklistDetailDataLoading: Ref<boolean> = ref(false);
const isLoading = computed(() => store.state.Org.isLoadingOrg);
const currentOrg = computed(() => store.state.Org.currentOrg);
const isMenuPin = computed(
  () =>
    store.state.Navigation.chevronActive && store.state.Navigation.isMenuOpen,
);

watch(
  () => currentOrg.value.orgId,
  (newVal, oldVal) => {
    if (newVal !== oldVal && newVal && oldVal) {
      getTemplate();
      getChecklistAssessment();
    }
  },
);

const pageLoaded = () => {
  setTimeout(() => {
    if (isLoading.value) {
      EventEmitter.emit(EmitterEvents.PAGE_LOADING_COMPLETED);
    }
  }, 500);
};

onMounted(async () => {
  try {
    await getTemplate();
    await initial();
    await getChecklistAssessment();
    const param = route?.query?.param;
    if (param) {
      openCreateAssessmentModal();
    }
  } catch (error) {
    showErrorAPI(error, Assessment.getChecklists);
  }
});

onUnmounted(() => {
  window.removeEventListener("click", () => {});
});

const handleRefresh = async () => {
  await getTemplate();
  await initial();
  await getChecklistAssessment();
};

const initial = async () => {
  const userData = JSON.parse(
    localStorage.getItem(localStorageKey.currentUserData) || "{}",
  );
  store.dispatch("User/getUserProfile", userData.userId);
  window.addEventListener("click", (e: any) => {
    if (!document.getElementById("click-box-assessment")?.contains(e.target)) {
      (backgroundRef as any).animation &&
        (backgroundRef as any).animation.reloadToggle();
    }
  });
};

onBeforeUnmount(() => {
  window.removeEventListener("click", () => {});
});

const checklistDetailData = computed(() => {
  return processChecklistData(
    cloneDeep(store.state.Assessment.checklistAssessment),
  );
});

const getChecklistAssessment = async () => {
  try {
    isChecklistDetailDataLoading.value = true;
    const res = await store.dispatch("Assessment/fetchChecklistAssessment");
    const checklist: IAssessmentDetail[] = get(res, "data.data", []);
    // checklistDetailData.value = processChecklistData(checklist);

    await store.dispatch("Assessment/fetchChecklistAssessmentDetail");
    await store.dispatch("Assessment/getAllScoreDetail");
    if (isLoading.value) {
      EventEmitter.emit(EmitterEvents.PAGE_LOADING_COMPLETED);
    }
  } catch (error) {
    showErrorAPI(error, Assessment.getChecklists);
  } finally {
    isChecklistDetailDataLoading.value = false;
  }
};

const openCreateAssessmentModal = async () => {
  createAssessmentShow.value = true;
  await localStorage.removeItem(localStorageKey.assessmentView);
  await localStorage.removeItem(localStorageKey.isHideComplete);
  await localStorage.removeItem(localStorageKey.showMasterItems);
  store.commit("Assessment/INITIALISE");
};

const processChecklistData = (data: IAssessmentDetail[]) => {
  let result: IAssessmentDetail[] = [];
  if (!data || data.length === 0) {
    assessmentsHistory.value = [];
    return result;
  }

  const checklistTreeWithoutArchivedSort =
    processChecklistAssessmentDataNewVerson(data);
  assessmentsHistory.value = checklistTreeWithoutArchivedSort.map((e) => {
    return {
      name: e.checklistName,
      state: e.checklistStatus,
      date: getTime(e.checklistDateCreated),
      isLarge: false,
      id: e.checklistId,
      history: e.checklistAssessmentHistory,
      checklistInforDetail: {
        checklistId: e.checklistId,
        checklistStatus: e.checklistStatus,
        checklistStatusId: e.checklistStatusId,
      },
    };
  });
  return checklistTreeWithoutArchivedSort;
};

const resetModalHistory = () => {
  assessmentsHistory.value.forEach((e: any) => {
    e.isLarge = false;
    e.history.forEach((el) => {
      el.isActive = false;
    });
  });
};

const handleSelectAssessment = ($event) => {
  const index = listAssessmentSelected.findIndex((item) => item === $event);

  if (index !== -1) listAssessmentSelected.splice(index, 1);
  else listAssessmentSelected.push($event);

  if (listAssessmentSelected.length >= 1) isActiveBulkActions.value = true;
  else isActiveBulkActions.value = false;
  assessmentSelectedCount.value = listAssessmentSelected.length;
};

const getTemplate = async () => {
  await store.dispatch("Assessment/getTemplate");
};

const getTime = (time: string) => {
  return convertUTCTimeToLocalTime(time);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppBarLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(BrandPattern4, {
          ref: "animation",
          page: "APPBARLAYOUT"
        }, null, 512),
        _createVNode(backgroundComponent, {
          ref_key: "backgroundRef",
          ref: backgroundRef
        }, null, 512),
        _createVNode(ActivePathWrapper, {
          "active-hierarchy": [
            _unref(getComponentUiText)('app-menu-assess-1'),
            _unref(getComponentUiText)('app-menu-submenu-assess-manage-assessments-1'),
          ]
        }, null, 8, ["active-hierarchy"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(getComponentUiText)("app-manage-assessment-title-1")), 1)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(`content-wrapper ${isMenuPin.value ? 'content-wrapper-pin' : ''}`)
        }, [
          _createElementVNode("div", {
            id: "click-box-assessment",
            class: _normalizeClass(`2xl:tw-w-[1040px] tw-gap-0 content assessment-container ${
              isMenuPin.value ? 'assessment-container-pin content-pin' : ''
            }`)
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("p", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(getComponentUiText)("app-assessment-title-1")), 1)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(ButtonBulkActions, {
                    "id-popover": 'popover-btn-bulk-action-assessment',
                    active: _unref(isActiveBulkActions),
                    "selected-number": assessmentSelectedCount.value
                  }, null, 8, ["active", "selected-number"]),
                  _createVNode(ButtonFilter, {
                    active: false,
                    "id-popover": 'popover-btn-filter-assessment',
                    "button-class": "tw-mr-5"
                  }),
                  _createVNode(IconButton, {
                    src: "/img/plus_icon.svg",
                    onClick: openCreateAssessmentModal
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                (
                    isChecklistDetailDataLoading.value &&
                    checklistDetailData.value?.length === 0
                  )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(checklistDetailData.value, (item, index) => {
                  return (_openBlock(), _createBlock(AssessmentDetails, {
                    key: `${item.checklistDateEdited}${item.checklistId}`,
                    index: index,
                    "id-popover": `popover-assessment-details-${index}`,
                    "id-popover-show-duplicate-assessment": `popover-btn-show-duplicate-assessment-detail-setting-${index}`,
                    details: _unref(addCurrentItemToChild)(item),
                    "checklist-id": item.checklistId,
                    "show-details": index === 0,
                    "onSelect:assessment": handleSelectAssessment,
                    onLoaded: _cache[0] || (_cache[0] = 
                    () => {
                      isChecklistDetailDataLoading.value = false;
                      pageLoaded();
                    }
                  ),
                    onOnRefresh: handleRefresh
                  }, null, 8, ["index", "id-popover", "id-popover-show-duplicate-assessment", "details", "checklist-id", "show-details"]))
                }), 128)),
                _createVNode(AssessmentCreateButton, {
                  title: 
                    checklistDetailData.value?.length
                      ? _unref(getComponentUiText)(
                          'app-assessment-button-create-button-1',
                        )
                      : _unref(getComponentUiText)(
                          'app-assessment-button-create-button-2',
                        )
                  ,
                  onClick: openCreateAssessmentModal
                }, null, 8, ["title"])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(ActionButton, { "profile-actions": profileActions })
            ])
          ], 2)
        ], 2)
      ]),
      _createVNode(CreateAssessmentModal, {
        show: createAssessmentShow.value,
        "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((createAssessmentShow).value = $event)),
        "assessments-history": assessmentsHistory.value,
        onResetModalHistory: resetModalHistory,
        onOpenManageTemplateModal: _cache[2] || (_cache[2] = 
          () => {
            createAssessmentShow.value = false;
            showModalManageTemplate.value = true;
          }
        )
      }, null, 8, ["show", "assessments-history"]),
      _createVNode(ManageTemplateModal, {
        show: showModalManageTemplate.value,
        "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((showModalManageTemplate).value = $event))
      }, null, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})